var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.40186dd37f48911e19b1afa3da02ab43.svg#k';
                    var viewUrl = 'sprites.40186dd37f48911e19b1afa3da02ab43.svg#view-k';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };